import { SOLVE_ARTICLES } from "./solve.js";
import { FLOW_STRATEGY_ARTICLES } from "./flow-strategy.js";
import { PLATFORM_ARTICLES } from "./platform.js";
export const KNOWLEDGE_DOMAINS = [
    {
        id: "solve",
        name: "SOLVE",
        shortName: "S",
        kicker: "Problem solving",
        description: "A zero-blame, evidence-led method for moving from a performance gap to a countermeasure that lasts.",
    },
    {
        id: "vsm",
        name: "VSM",
        shortName: "V",
        kicker: "Value stream mapping",
        description: "See the whole flow of value, make delay and waste visible, and design a better future state together.",
    },
    {
        id: "hoshin",
        name: "Hoshin",
        shortName: "H",
        kicker: "Strategy deployment",
        description: "Turn a small number of breakthrough priorities into aligned targets, ownership, action, and review.",
    },
    {
        id: "lama",
        name: "LAMA",
        shortName: "L",
        kicker: "Maturity assessment",
        description: "Build an honest, evidence-based view of capability and use the gaps to choose the next practical improvement.",
    },
    {
        id: "player-ai",
        name: "Player AI",
        shortName: "AI",
        kicker: "Personal AI coach",
        description: "A personal coaching layer that connects day-to-day execution with learning, reflection, and capability growth.",
    },
    {
        id: "platform",
        name: "Using the app",
        shortName: "Start",
        kicker: "Everyday work",
        description: "Find your work, use shared workspaces, and make the app work for you.",
    },
    {
        id: "admin",
        name: "Admin Console",
        shortName: "Admin",
        kicker: "Workspace administration",
        description: "Manage members, identity, modules, connections, and workspace policies.",
    },
];
export const KNOWLEDGE_ARTICLES = [
    ...SOLVE_ARTICLES,
    ...FLOW_STRATEGY_ARTICLES,
    ...PLATFORM_ARTICLES,
];
export const SECTION_LABELS = {
    framework: "Understand the method",
    software: "Use the software",
    workshop: "Facilitator guides",
    practice: "Try it yourself",
    reference: "Reference and troubleshooting",
};
//# sourceMappingURL=articles.js.map